document.addEventListener("DOMContentLoaded", function() {
    let counters = document.querySelectorAll('.counter');

    counters.forEach(function(counter) {
        let count = 0;
        let endValue = parseInt(counter.getAttribute('data-end-value'), 10);
        let increment = Math.ceil(endValue / 100); // Increment um den Zähler schneller zu erhöhen
        let animationStarted = false;

        function updateCounter() {
            count += increment; // Inkrementieren Sie den Zähler um den Wert von "increment"
            
            // Begrenzen Sie den Zählerwert auf den Endwert, um sicherzustellen, dass er nicht darüber hinausgeht
            if (count > endValue) {
                count = endValue;
            }

            counter.textContent = count;

            // Überprüfen, ob der Zähler den Endwert erreicht hat
            if (count >= endValue) {
                clearInterval(interval); // Stoppen des Intervalls
            }
        }

        function startCounterOnScroll() {
            if (isElementInViewport(counter) && !animationStarted) {
                animationStarted = true;
                interval = setInterval(updateCounter, 5); // 20 Millisekunden für ein schnelleres Hochzählen
            }
        }

        function isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        // Setzen Sie das Intervall nur, wenn das Element im Sichtfeld des Benutzers ist
        window.addEventListener('scroll', startCounterOnScroll);
    });
});